import {IPreloader} from '@fantasmagames/core/src/loader/Preloader';
import {Device} from '@fantasmagames/core/src/device/Device';
import {ICustomPreloaderView} from '@fantasmagames/core/src/loader/BaseMicorgamingPreloaderView';
import {MicrogamingPreloaderUtils} from '@fantasmagames/core/src/loader/MicrogamingPreloaderUtils';

export class MicrogamingPreloaderV2 implements IPreloader {
	protected _view: ICustomPreloaderView;
	protected _device: Device;
	protected _getUrlPath: (path: string) => string;
	protected _preloaderViewClass: any;
	protected _onResizeBind: any;

	protected _hasPublisherSplash: boolean = true;

	protected _publisherName: string;
	protected _isPoweredByEnabled: boolean;
	protected _canHaveFantasmaStuff: boolean;
	protected _canUpdateProgress: boolean = false;

	constructor(baseUrlPath: Function, device: Device, preloaderViewClass: any) {
		this._getUrlPath = device.isMobile ?
			(path) => baseUrlPath('resources/Mobile/' + path) :
			(path) => baseUrlPath('resources/Desktop/' + path);
		this._device = device;
		this._preloaderViewClass = preloaderViewClass;

		// load Microgaming css styles
		const _link = document.createElement('link');
		_link.type = 'text/css';
		_link.rel = 'stylesheet';
		_link.href = MicrogamingPreloaderUtils.getContentUrl() + MicrogamingPreloaderUtils.getPublisherPath() + 'pub.css';
		document.head.appendChild(_link);

		// if (!__PRODUCTION__) {
		// 	// Overide brand temporarily.
		// 	const brand: string = Publishers.DGC;
		//
		// 	if (brand) {
		// 		(window as any).mgsConfig.casinoInfo.publisher = brand;
		// 		(window as any).mgsConfig.branding.publisher.path = (window as any).mgsConfig.branding.publisher.path.replace('mgs', brand);
		// 	}
		// }

		if ((window as any).mgsConfig.casinoInfo.publisher) {
			this._publisherName = (window as any).mgsConfig.casinoInfo.publisher;
		}

		if ((window as any).mgsConfig.branding) {
			this._isPoweredByEnabled = (window as any).mgsConfig.branding.poweredBy.enabled;
		}

		this._canHaveFantasmaStuff = this._isPoweredByEnabled && (this._publisherName === 'mgs' || this._publisherName === 'quickfire');
		(window as any)._canHaveFantasmaStuff = this._canHaveFantasmaStuff;
	}

	public getExtraConfigLogic(): any {
		return null;
	}

	public createLoadingScreen(): void {
		this.checkIfPublisherSplashExists(() => {
			const config = this.getConfig();
			this._view = new this._preloaderViewClass();
			const parentItem: HTMLElement = document.getElementById('preloader');
			this._view.init(parentItem, config, this._getUrlPath);
			this._onResizeBind = this.onResizeEvent.bind(this);
			window.addEventListener('resize', this._onResizeBind);
			this.onResizeEvent();
			this._canUpdateProgress = true;
		});

	}

	public endLoading(): void {
		this._view.endLoading();
		window.removeEventListener('resize', this._onResizeBind);
	}

	public updateProgress(totalItems: number, current: number): void {
		if (this._canUpdateProgress) {
			this._view.updateProgress(totalItems, current);
		}
	}

	public usingUnsupportedDeviceOrBrowser(): void {
	}

	protected checkIfPublisherSplashExists(callback: Function): void {

		const msgConfig = (window as any).mgsConfig;
		const publisherName = msgConfig.casinoInfo.publisher;

		let triedLoads: number = 0;
		let totalShouldLoad: number = 1;

		const onerror = () => {
			this._hasPublisherSplash = false;
			triedLoads += 1;
			if (triedLoads >= totalShouldLoad) {
				callback && callback();
			}
		};

		const onload = () => {
			this._hasPublisherSplash = this._hasPublisherSplash && true;
			triedLoads += 1;
			if (triedLoads >= totalShouldLoad) {
				callback && callback();
			}
		};

		switch (publisherName) {
			case Publishers.DGC:
			case Publishers.Microgaming_Asia:
			case Publishers.UPG:
			case Publishers.Microgaming:
			case Publishers.Microgaming_QuickFire:
				if (publisherName === Publishers.DGC || publisherName === Publishers.UPG || publisherName === Publishers.Microgaming_Asia) {
					// Try loading PublisherSplash.jpg and PublisherSplashPortrait.jpg.
					totalShouldLoad = 2;

					if (publisherName === Publishers.DGC) {
						// Try loading PublisherSplash.jpg, PublisherSplashPortrait.jpg and disclaimer.png
						totalShouldLoad = 3;

						const checkPublisherLogo = MicrogamingPreloaderUtils.createImage('PublisherDisclaimer');
						checkPublisherLogo.onerror = onerror;
						checkPublisherLogo.onload = onload;
						checkPublisherLogo.src = `${MicrogamingPreloaderUtils.getPublisherLogoPathRoot(false)}disclaimer.png`;
					}

					const checkPublisherLogo = MicrogamingPreloaderUtils.createImage('PublisherSplash');
					const checkPublisherPortraitLogo = MicrogamingPreloaderUtils.createImage('PublisherSplashPortrait');
					checkPublisherLogo.onload = onload;
					checkPublisherLogo.onerror = onerror;
					checkPublisherPortraitLogo.onload = onload;
					checkPublisherPortraitLogo.onerror = onerror;
					checkPublisherLogo.src = `${MicrogamingPreloaderUtils.getPublisherLogoPathRoot(true)}/PublisherSplash.jpg`;
					checkPublisherPortraitLogo.src = `${MicrogamingPreloaderUtils.getPublisherLogoPathRoot(true)}/PublisherSplashPortrait.jpg`;
				} else {
					const checkPublisherLogo = MicrogamingPreloaderUtils.createImage('PublisherLogo');
					checkPublisherLogo.onerror = onerror;
					checkPublisherLogo.onload = onload;
					checkPublisherLogo.src = `${MicrogamingPreloaderUtils.getPublisherLogoPathRoot(false)}logo.png`;
				}

				break;
			default:
				callback && callback();
				break;
		}

	}

	protected getConfig(): IMicroGamingPreloaderConfig {
		const msgConfig = (window as any).mgsConfig;

		const config: IMicroGamingPreloaderConfig = {
			loadingBarColor: LoadingBarColor.STUDIO,
			contentRequired: [LoaderParts.GAME, LoaderParts.STUDIO],
			poweredBy: false,
			extra: null,
			publisherName: null,
			publisherFallback: null,
			usePublisherFallback: false,
			hasPublisherSplash: false,
			setDesign: false,
		};

		if (msgConfig.casinoInfo.publisher) {
			let publisherName = msgConfig.casinoInfo.publisher;
			config.poweredBy = msgConfig.branding.poweredBy.enabled;
			config.publisherName = publisherName;
			config.hasPublisherSplash = this._hasPublisherSplash;

			if (!this._hasPublisherSplash) {
				// Some resource is mising. Default to Game Brand only.
				publisherName = '';
			}

			switch (publisherName) {
				case Publishers.Microgaming:
					config.setDesign = false;
					config.loadingBarColor = LoadingBarColor.WHITE;
					config.contentRequired = config.poweredBy ?
						[LoaderParts.PUBLISHER_LOGO, LoaderParts.STUDIO, LoaderParts.LOADING_BAR] :
						[LoaderParts.GAME, LoaderParts.LOADING_BAR];
					break;
				case Publishers.Microgaming_QuickFire:
					config.setDesign = false;
					config.loadingBarColor = LoadingBarColor.WHITE;
					config.contentRequired = config.poweredBy ?
						[LoaderParts.PUBLISHER_LOGO, LoaderParts.STUDIO, LoaderParts.LOADING_BAR] :
						[LoaderParts.GAME, LoaderParts.LOADING_BAR];
					break;
				case Publishers.Microgaming_Asia:
					config.setDesign = true;
					config.loadingBarColor = LoadingBarColor.WHITE;
					config.contentRequired = [LoaderParts.PUBLISHER_LOGO, LoaderParts.LOADING_BAR];
					break;
				case Publishers.UPG:
					config.setDesign = true;
					config.loadingBarColor = LoadingBarColor.WHITE;
					config.contentRequired = [LoaderParts.PUBLISHER_LOGO, LoaderParts.LOADING_BAR];
					break;
				case Publishers.DGC:
					config.setDesign = true;
					config.loadingBarColor = LoadingBarColor.MULTI_COLORED;
					config.contentRequired = [LoaderParts.PUBLISHER_LOGO, LoaderParts.DISCLAIMER, LoaderParts.LOADING_BAR];
					break;
				default:
					config.setDesign = false;
					config.loadingBarColor = LoadingBarColor.STUDIO;
					config.contentRequired = [LoaderParts.GAME, LoaderParts.LOADING_BAR];
					break;
			}
		}

		if (this.getExtraConfigLogic()) {
			config.extra = this.getExtraConfigLogic();
		}

		return config;
	}

	protected onResizeEvent(): void {
		setTimeout(
			() => {
				this._view.resize(this._device);
			},
			(this._device.iOS && this._device.isIOSChrome) || this._device.isIOSMobileRequestingDesktop ? 200 : 0,
		);
	}
}

export interface IMicroGamingPreloaderConfig {
	loadingBarColor: LoadingBarColor;
	contentRequired: LoaderParts[];
	poweredBy: boolean;
	extra: any;
	publisherName: string;
	publisherFallback: string;
	usePublisherFallback: boolean;
	setDesign: boolean;
	hasPublisherSplash: boolean;
}

export enum LoadingBarColor {
	WHITE,
	STUDIO,
	MULTI_COLORED,
}

export enum Publishers {
	Microgaming = 'mgs', Microgaming_QuickFire = 'quickfire', Microgaming_Asia = 'mgsasia', UPG = 'upg', DGC = 'dgc',
}

export enum LoaderParts {
	STUDIO, GAME, PUBLISHER_LOGO, DISCLAIMER, LOADING_BAR,
}



// WEBPACK FOOTER //
// ./@fantasmagames/core/src/loader/MicrogamingPreloaderV2.ts